<div class="container-fluid myIndex">
  <div class="col-md-12"    *ngIf="isLoading"  style="position: fixed;top: 0;left: 0; width: 100%; height: 100%; z-index: 99; " >
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="blue_header">
    <h1 class="heading">Manage Vehicles</h1>
  </div>
  <div class="row"*ngIf="!isPermitApplication && !isInStepper">
    <div class="col-md-12">
    <a [routerLink]="['/carrier/accounts/VCA']"> <img src="../../../assets/newimg/arrow-1-3@2x.png" style="cursor: pointer;margin: 10px;"  /></a>
    </div>
  </div>

  <fieldset class="fieldset_card">
    <div
      class="row"
      style="padding: 12px; width: 250px; display: none"
      rowspan="2"
    >
      <button
        data-dismiss="modal"
        id="actionAddVehicle"
        title="Add a vehicle"
        class="btn-add-vehicle btn btn-primary btn-sm mr-2"
        data-toggle="modal"
        data-target="#addEdit"
        (click)="createForm()"
      >
        <img
          class="myButton"
          style="color: white"
          src="../../../../../assets/newimg/add-circle-4@2x.png"
          height="15"
        />
        Add vehicle
      </button>
    </div>
    <app-filter [showVehicleFilter]="true"></app-filter>
<br/>
    <div class="search_row" style="display: none">
      <label class="filter-title">Search your Existing Vehicles </label>
      <div class="column">
        <!-- <label class="filter-title">Please search your vehicle</label> -->
        <select
          title="Select vehicle type..."
          class="form-control"
          [(ngModel)]="vehicleType"
        >
          <option value="" disabled selected hidden>Vehicle Type</option>
          <option value="">Select none</option>
          <option
            *ngFor="let vehicletype of vehicletypes"
            [value]="vehicletype.id"
          >
            {{ vehicletype.description }}
          </option>
        </select>
      </div>
      <div class="column">
        <!-- <label class="filter-title">Please search your vin Number</label> -->
        <input
          type="text"
          class="form-control pull-left"
          [(ngModel)]="vinnumber"
          placeholder="Enter VIN Number..."
          title="VIN number to search for..."
        />
      </div>
      <div class="column">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="regnumber"
          placeholder="Enter Registration Number..."
          title="Register number to search for."
        />
      </div>

      <!-- <div class="" style="width: 14%!important; padding: 2px !important; ;margin:1px!important;">
      <input type="text" class="form-control form-control-lg" [(ngModel)]="carriername"
        placeholder="Enter Carrier Name..." title="Carrier Name to search for.">
    </div> -->

      <!-- <div class="" style="width: 14%!important; padding: 2px !important; ;margin:1px!important;">
      <input type="text" class="form-control form-control-lg" [(ngModel)]="carriercode"
        placeholder="Enter Carrier Code..." title="Carrier Code to search for.">
    </div> -->

      <div class="col-1 btn-show">
        <button
          title="Apply filters..."
          id="btnSearch"
          
          (click)="VehicleSearch()"
          class="btn btn_primary btn-md"
          style="margin-right: 4px !important"
          ><i class="fa fa-search" aria-hidden="true"></i
        ></button>
        <!-- <span
          title="Apply filters..."
          *ngIf="isMyVehicles"
          (click)="onCarrierSearch()"
          class="btn btn_primary btn-md"
          style="margin-right: 4px !important"
          ><i class="fa fa-search" aria-hidden="true"></i
        ></span> -->
        <span
          (click)="onReset()"
          title="Reset filters..."
          id="btnReset"
          class="btn btn_primary btn-md"
          ><i class="fa fa-undo" aria-hidden="true"></i
        ></span>
      </div>
    </div>
  </fieldset>

  <div>
<!--    <app-actions-->
<!--      *ngIf="isMyVehicles"-->
<!--      [selectedVehicle]="selectedVehicle"-->
<!--      [user]="user"-->
<!--    ></app-actions>-->

    <app-actions
            [isVehicleActions] = "true"
            [selectedVehicle]="selectedVehicle"
            [user]="user"
    ></app-actions>
  </div>
  <!-- <div class="actions screen" >
  <div class="container" class="overlap-group3">
      <div class="row">
          <div 
               class="col-sm">
              <a [routerLink]="" class="btn btn-default" id="actionAddVehicle" value="0"
                 (click)="actionClicked(0,selectedVehicle)">
                  <span >Add Vehicle</span>
              </a>
          </div>
          <div 
               class="col-sm">
              <a [routerLink]="" class="btn btn-default" id="actionDelete" value="'0'"
                 (click)="actionClicked(1,selectedVehicle)">
                  <span class="hidden-xs hidden-sm">Delete</span>
              </a>
          </div>
          <div 
               class="col-sm">
              <a [routerLink]="" class="btn btn-default" id="actionUploadDocuments" value="'0'"
                 (click)="actionClicked(2,selectedVehicle)">
                  <span class="hidden-xs hidden-sm">Upload Documents</span>
              </a>
          </div>
          <div 
               class="col-sm">
              <a [routerLink]="" class="btn btn-default" id="actionView" value="'0'"
                 (click)="actionClicked(3,selectedVehicle)">
                  <span class="hidden-xs hidden-sm">View</span>
              </a>
          </div>
         

      </div>
  </div> -->
  <br />

  <div class="table-responsive">
    <table class="table custom_table">
      <thead class="" style="background: white !important; border-top: none">
        <tr class="hd-clpse">
          <th
            class="bfr-end-col"
            *ngIf="isMyVehicles && selectedVehicles.length > 0"
          >
            <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagAN == 2),'fa-sort-desc sort-d': (flags.flagAN == 3), 'fa-sort':(flags.flagAN == 1) }" (click)="onSort(1)"></i> -->
            <div>
              <button
                title="Back"
                type="button"
                id="btnBack"
                (click)="addSelectedVehicles()"
                class="btn btn-md btn-primary"
              >
                Add Selected to Application
              </button>
            </div>
          </th>
         <th *ngIf="isMyVehicles && selectedVehicles.length === 0">
            <div>Select Vehicle</div>
          </th> 
          <th data-column class="bfr-end-col">
            Vin
            <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagAN == 2),'fa-sort-desc sort-d': (flags.flagAN == 3), 'fa-sort':(flags.flagAN == 1) }" (click)="onSort(1)"></i> -->
          </th>
          <th data-column class="bfr-end-col">
            Country of registration
            <!-- <i style="vertical-align:middle; float:right;" class="fa " [ngClass]="{'fa-sort-asc sort-a': (flags.flagST == 2),'fa-sort-desc sort-d': (flags.flagST == 3), 'fa-sort':(flags.flagST == 1) }" (click)="onSort(7)"></i> -->
          </th>
          <th data-column class="bfr-end-col">
            Vehicle Type
            <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagAN == 2),'fa-sort-desc sort-d': (flags.flagAN == 3), 'fa-sort':(flags.flagAN == 1) }" (click)="onSort(1)"></i> -->
          </th>
          <th data-column class="bfr-end-col">
            Registration Number
            <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagNM == 2),'fa-sort-desc sort-d': (flags.flagNM == 3), 'fa-sort':(flags.flagNM == 1) }" (click)="onSort(2)"></i> -->
          </th>
          <th data-column class="bfr-end-col">
            eNatis Number
            <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagNM == 2),'fa-sort-desc sort-d': (flags.flagNM == 3), 'fa-sort':(flags.flagNM == 1) }" (click)="onSort(2)"></i> -->
          </th>
          <th data-column class="bfr-end-col" class="text-right">
            Licence Expiry Date
            <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagLU == 2),'fa-sort-desc sort-d': (flags.flagLU == 3), 'fa-sort':(flags.flagLU == 1) }" (click)="onSort(3)"></i> -->
          </th>
          <th data-column class="bfr-end-col">
            GVM
            <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagCT == 2),'fa-sort-desc sort-d': (flags.flagCT == 3), 'fa-sort':(flags.flagCT == 1) }" (click)="onSort(4)"></i> -->
          </th>
          <th data-column class="bfr-end-col">
            Seating Capacity
            <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagAP == 2),'fa-sort-desc sort-d': (flags.flagAP == 3), 'fa-sort':(flags.flagAP == 1) }" (click)="onSort(5)"></i> -->
          </th>
          <th data-column class="bfr-end-col">
            Road Worthiness
            <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagPT == 2),'fa-sort-desc sort-d': (flags.flagPT == 3), 'fa-sort':(flags.flagPT == 1) }" (click)="onSort(6)"></i> -->
          </th>
          <th data-column class="bfr-end-col">
           Depot
            <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagPT == 2),'fa-sort-desc sort-d': (flags.flagPT == 3), 'fa-sort':(flags.flagPT == 1) }" (click)="onSort(6)"></i> -->
          </th>
          <th  data-column class="bfr-end-col">
            Actions
          </th>
          <!--
	<th class="bfr-end-col" rowspan="2">
	  Name of owner
	</th> -->
          <!-- <th class="bfr-end-col end-col" colspan="5">
	  Last permit issued
	</th>
  </tr> -->

          <!-- <tr>
	<th class="bfr-end-col">Permit Number</th>
	<th class="bfr-end-col">Permit Type</th>
	<th class="bfr-end-col">Permit Expiry Date</th>
	<th class="bfr-end-col">Permit Status</th> -->
          <!-- <th *ngIf="isMyVehicles" class="bfr-end-col" rowspan="2" >
	  <button data-dismiss="modal" title="Add a vehicle" class="btn-add-vehicle btn btn-primary btn-sm mr-2"
		data-toggle="modal" data-target="#addEdit" (click)="createForm()">
		<img src="../../../../../assets/newimg/add-circle-4@2x.png" height="15"/> Add vehicle
	  </button>
	</th> -->
        </tr>
      </thead>
      <tbody>
        <!-- <tr class="tbl-row"
	*ngFor="let item of vehicleRes | paginate: {itemsPerPage:pageSize, currentPage: page ,totalItems: count}"> -->
  
        <tr class="tbl-row" *ngFor="let item of vehicleRes | paginate: {itemsPerPage:pageSize, currentPage: currentPage , id: 'apps', totalItems: count}">
          <td data-column *ngIf="item.VehicleEntry != null">
            <input
              type="checkbox"
              class="form-control input-sm form-control-sm"
              [title]="chkboxToolTip(item.vehicle_type)"
              [disabled]="cabotageTrailer(item.vehicle_type)"
              (change)="checkVehicle($event, item, item)"
            />
          </td>
          <td data-column *ngIf="item.VehicleEntry != null">
            <span>{{ item.VehicleEntry.vin }}</span>
          </td>
          <td data-column *ngIf="item.VehicleEntry == null">
            <span>{{ item.vin }}</span>
          </td>
          <td data-column *ngIf="item.VehicleEntry != null">
            <ng-container *ngFor="let cnt of ddlCountries">
              <span *ngIf="item.VehicleEntry.country_id == cnt.id">{{
                cnt.desc
              }}</span>
            </ng-container>
          </td>
          <td data-column *ngIf="item.VehicleEntry == null">
            <ng-container *ngFor="let cnt of ddlCountries">
              <span *ngIf="item.country_id == cnt.id">{{ cnt.desc }}</span>
            </ng-container>
          </td>
          <td data-column>{{ item.vehicle_type }}</td>
          <td data-column *ngIf="item.VehicleEntry != null">
            <span>{{ item.VehicleEntry.registration_number }}</span>
          </td>
          <td data-column *ngIf="item.VehicleEntry == null">
            <span>{{ item.registration_number }}</span>
          </td>
          <td data-column *ngIf="item.VehicleEntry != null">
            {{ item.VehicleEntry.vehicle_register_num }}
          </td>
          <td data-column *ngIf="item.VehicleEntry == null">
            {{ item.vehicle_register_num }}
          </td>
          <td data-column *ngIf="item.VehicleEntry != null" class="text-right">
            <span>{{
              item.VehicleEntry.date_license_expiry | date : "dd/MM/yyyy"
            }}</span>
          </td>
          <td data-column *ngIf="item.VehicleEntry == null" class="text-right">
            <span>{{ item.date_license_expiry | date : "dd/MM/yyyy" }}</span>
          </td>

          <td data-column *ngIf="item.VehicleEntry != null">
            <span>{{ item.VehicleEntry.gvn }}</span>
          </td>
          <td data-column *ngIf="item.VehicleEntry == null">
            <span>{{ item.gvn }}</span>
          </td>

          <td data-column *ngIf="item.VehicleEntry != null">
            <span>{{ item.VehicleEntry.seating_capacity }}</span>
          </td>
          <td data-column *ngIf="item.VehicleEntry == null">
            <span>{{ item.seating_capacity }}</span>
          </td>

          <td data-column *ngIf="item.VehicleEntry != null">
            <span>{{ item.VehicleEntry.roadworthy_status }}</span>
          </td>
          <td data-column *ngIf="item.VehicleEntry == null">
            <span>{{ item.roadworthy_status }}</span>
          </td>
          <td data-column>
            <span>{{ item.Depot?.name }}</span>
          </td>

          <!-- <td><span *ngIf="item.Permit!=null">{{item.Permit.permit_num}}</span></td>
	<td><span *ngIf="item.Permit!=null">
	  <ng-container *ngFor="let lis of permittypes">
		<ng-container *ngIf="lis.id==item.Permit.permit_type_id">{{lis.description}}</ng-container>
	  </ng-container></span>
	</td>
	<td><span *ngIf="item.Permit!=null">{{item.Permit.date_valid_to}}</span></td>
	<td><span *ngIf="item.Permit!=null">{{item.Permit.status_description}}</span></td> -->
  <td>
    <div class="actions">
      <button
        type="button"
        (click)="actionClicked(1,item)"
        class="btn_icon"
        aria-label="Edit Vehicle"
      >
        <img src="assets/edit.png" alt="" />
      </button>
      <button
        type="button"
        class="btn_icon"
        (click)="actionClicked(3,item)"
        aria-label="Delete Vehicle"
      >
        <img src="assets/delete.png" alt="" />
      </button>
      <button
        type="button"
        (click)="actionClicked(0,item)"
        class="btn_icon"
        aria-label="View Vehicle"
      >
        <img src="assets/visibility.png" alt="" />
      </button>
    </div>
  </td>
          <td
            style="display: none"
            class="btn-show end-col"
          >
            <select
              style="display: none"
              class="form-control action"
              name="action"
              (change)="selectAction(action, item)"
              #action
            >
              <option style="display: none" value="null">Select</option>
              <option
                (change)="selectAction(action, item)"
                style="display: none"
                value="edit"
              >
                Edit
              </option>
              -->
              <option
                id="actionDelete"
                (click)="actionClicked(3, selectedVehicle)"
                style="display: none"
                value="0"
              >
                Delete
              </option>
              <option
                id="actionUploadDocuments"
                (click)="actionClicked(2, selectedVehicle)"
                style="display: none"
                value="0"
              >
                Upload Documents
              </option>
              <option
                id="actionUpdateHistory"
                (click)="actionClicked(1, selectedVehicle)"
                style="display: none"
                value="0"
              >
                Update History
              </option>
              <option
                id="actionView"
                (click)="actionClicked(0, selectedVehicle)"
                style="display: none"
                value="0"
              >
                View
              </option>
            </select>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <!-- <tr style="padding-left:0px;margin-left:0px;">
	<td colspan="8" class="rm-brd" style="padding-left:0px;margin-left:0px;">
	  <div *ngIf="!IsSearching" class="row">
		<div class="col-2">
		  <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
			<div class="input-group-prepend">
			  <label class="input-group-text form-control-sm show-h" for="show-id">Show:</label>
			</div>
			<select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="pageSize" (change)="onChange()">
			  <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
			</select>
		  </div>
		</div>
		<div class="col-8 text-center" >
		  <pagination-controls (pageChange)="utility.page = onNextOrPrevious($event)"
			style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
		</div>
	  </div>
	  <div *ngIf="IsSearching" class="row">
		<div class="col-2">
		  <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
			<div class="input-group-prepend">
			  <label class="input-group-text form-control-sm show-h" for="show-id" >Show:</label>
			</div>
			<select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="pageSize" (change)="onChange()">
			  <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
			</select>
		  </div>
		</div>
		<div class="col-8 text-center">
		  <pagination-controls (pageChange)="utility.page = onNextOrPrevious($event)" style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
		</div>
	  </div>
	</td>
  </tr> -->
  <tr *ngIf="count > 0" class="pagination_row">
    <td colspan="12" class="rm-brd">
      <div class="row">
        <div class="col-2">
          <div
            class="input-group mb-3 rm-brd"
            style="width: 125px !important; height: 30px !important"
          >
            <div class="input-group-prepend">
              <label
                class="input-group-text form-control-sm show-h"
                for="show-id"
                >Show:</label
              >
            </div>
            <select
              class="form-control form-control-sm show-h"
              id="show-id" [(ngModel)]="pageSize" 
              (change)="onChange($event)"
            >
              <option
                *ngFor="let key of utility.pageItems"
                [ngValue]="key"
              >
                {{ key }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-10">
          <pagination-controls
            (pageChange)="utility.page = onNextOrPrevious($event)"
            style="
              margin-right: 0px !important;
              float: right !important;
            " id="apps"
          ></pagination-controls>
        </div>
      </div>
    </td>
  </tr>
        <tr *ngIf="isEmpty">
          <td colspan="4" class="rm-brd">
            <span class="text-info text-small" style="color: #274c9c !important"
              ><b>No vehicle entries found. Please add a new vehicle.</b></span
            >
          </td>
        </tr>
      </tfoot>
    </table>

    <!-- <div class="table_footer">
      <div class="row">
        <div class="col-2">
          <div
            class="input-group mb-3 rm-brd"
            *ngIf="vehicleRes.length > 0"
            style="width: 125px !important; height: 30px !important"
          >
            <div class="input-group-prepend">
              <label
                class="input-group-text form-control-sm show-h"
                for="show-id"
                >Show:</label
              >
            </div>
            <select
              class="form-control form-control-sm show-h"
              id="show-id"
              [(ngModel)]="pageSize"
              (change)="onChange()"
            >
              <option *ngFor="let key of utility.pageItems" [ngValue]="key">
                {{ key }}
              </option>
            </select>
          </div>
        </div>
      </div>
            
      <div class="column pagination_row">
        <div *ngIf="vehicleRes.length > 0">
          <pagination-controls
                    (pageChange)="utility.page = onNextOrPrevious($event)"
                    style="
                      margin-right: 0px !important;
                      float: right !important;
                    "
                  ></pagination-controls>
        </div>
        <pagination-template #p="paginationApi"></pagination-template>
      </div>
    </div> -->
    
    <div class="col-md-12" *ngIf="isMyVehicles">
      <button
        title="Back"
        type="button"
        (click)="onBack()"
        class="btn btn-md btn-primary pull-right"
        style="
          margin-left: 10px;
          background-color: white !important;
          color: #1d3f94 !important;
        "
      >
        Close
      </button>
    </div>

    <!-- <div class="action_btns"  *ngIf="isInStepper">
      <div class="btn_wrap">
        <a [routerLink]="['/carrier/accounts/VCA']" type="button" class="btn btn_secondary">Close</a>
      </div>
              <div class="btn_wrap" *ngIf="isInStepper">
                <button type="button" (click)="nextStep()" type="button" class="btn btn_secondary">Next</button>
              </div>

      <div class="btn_wrap">
        <button type="button" class="btn btn_primary" (click)="prevStep()">
          Back
        </button>
      </div>
    </div> -->
  </div>

  <!--ADD EDIT VIEW Modal -->
  <button
    data-dismiss="modal"
    title="Edit a vehicle"
    class="btn-add btn btn-primary btn-sm"
    data-toggle="modal"
    id="actionAddVehicle"
    data-target="#addEdit"
    id="myButton"
    hidden="true"
  >
    Edit Vehicle
  </button>
  <div
    class="modal fade"
    id="addEdit"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLongTitle"
    data-backdrop="false"
    style="background-color: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            *ngIf="isEditData == false && isViewData == false"
          >
            Add Vehicle
          </h5>
          <h5
            class="modal-title"
            *ngIf="isEditData == true && isViewData == false"
          >
            Edit Vehicle
          </h5>
          <h5
            class="modal-title"
            *ngIf="isViewData == true"
          >
            Vehicle Details
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            #closebutton
            aria-label="Close"
            (click)="close()"
            id="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-xl">
          <div
            class="col-md-12"
            *ngIf="isVehicleLoading"
            style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 99;
            "
          >
            <app-busy [message]="message"></app-busy>
          </div>
          <form [formGroup]="myForm">
            <div class="contact-details opensans-semi-bold-sapphire-30px">
              <span class="opensans-semi-bold-sapphire-30px"
                >Vehicle Details</span
              >
            </div>
            <div class="rectangle-34"></div>
            <br />

            <!-- 1st Row -->
            <div class="row">

              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  Country of Vehicle Registration<a class="red-asterik">*</a>
                </label>
                <!-- <select class="form-control form-control-sm" id="country_id" name="country_id"
									(change)="changeCountry(countryId)" #countryId formControlName="country_id"
									[attr.disabled]="disallowEdit ? '' : null">
									<option value="" disabled>Select country</option>
									<option *ngFor="let country of ddlCountries" [ngValue]="country.id" [selected]="country.desc == 'South Africa'">{{country.desc}}
									</option>
								</select> -->
                <select
                  class="form-control form-control-sm"
                  #country_id
                  name="country_id"
                  (change)="changeCountry(countryId)"
                  #countryId
                  [attr.disabled]="disallowEdit ? '' : null"
                >
                  <!-- <option value="" disabled>Select country</option> -->
                  <option
                    *ngFor="let country of ddlCountries"
                    [value]="country.id"
                    [selected]="country.desc == selectedCountry"
                  >
                    {{ country.desc }}
                  </option>
                </select>
                <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.country_id.required">Country of vehicle registration is required</p>
            </div> -->
              </div>

              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  VIN or Chassis Number<a class="red-asterik">*</a>
                </label>
                <input
                  type="text"
                  #vin
                  (keyup)="checkVin(vin.value)"
                  (onpaste)="checkVin(vin.value)"
                  class="form-control input-sm form-control-sm"
                  id="vin"
                  name="vin"
                  formControlName="vin"
                  [readOnly]="isViewData || disallowEdit"
                  oninput="this.value = this.value.toUpperCase()"
                />
              </div>

              <!-- Need to get from ENatis -->
              <!-- <div class="col-6 sp-fld" *ngIf="!isViewData && found==true">
              <label class="control-label hd-cat">
               </label>
               <button type="button" class="btn btn-md m-clr hd-btn mr-2 mt-2" style="width:100% !important;"  (click)="eNatisUpdate()">Retrieve from eNatis</button>
             </div> -->
            </div>
            <br />

            <!-- 2nd Row -->
            <!-- <div class="row">
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                VIN or Chassis Number<a class="red-asterik">*</a>
              </label>
              <input type="text" #vin (keyup)="checkVin(vin.value)" (onpaste)="checkVin(vin.value)" class="form-control input-sm form-control-sm" id="vin" name="vin"
                formControlName="vin" [readOnly]="isViewData || disallowEdit" oninput="this.value = this.value.toUpperCase()" />
            </div>
            <div class="col-4 sp-fld" *ngIf="!isViewData && found==true">
             <label class="control-label hd-cat">
              </label>
              <button type="button" class="btn btn-md m-clr hd-btn mr-2 mt-2" style="width:100% !important;"  (click)="eNatisUpdate()">Retrieve from eNatis</button>
            </div>
          </div>
          <br> -->

            <!-- 3rd Row -->
            <div class="row">
              <!-- <div class="col-4 sp-fld" *ngIf="found == false"> -->
              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  Vehicle Registration Number<a class="red-asterik">*</a>
                </label>
                <input
                  type="text"
                  #reg
                  maxlength="20"
                  class="form-control input-sm form-control-sm"
                  formControlName="registration_number"
                  [readonly]="isViewData || eNatisResult"
                />
                <!-- <div class="form-control-feedback text-danger text-small">
                <p *ngIf="myForm.controls.registration_number.required">Vehicle registration number is required</p>
              </div> -->
              </div>
              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  Engine Number<a class="red-asterik">*</a>
                </label>
                <input
                  type="text"
                  class="form-control input-sm form-control-sm"
                  id="engine_number"
                  name="engine_number"
                  formControlName="engine_number"
                  [readonly]="isViewData || eNatisResult"
                />
                <!-- <div class="form-control-feedback text-danger text-small">
                <p *ngIf="myForm.controls.engine_number.required">Engine number is required</p>
              </div>-->
              </div>
              <!-- <div class="col-4 sp-fld">
                <label class="control-label hd-cat">
                  Gross Vehicle (GVM)<a class="red-asterik">*</a>
                </label>
                <input type="text" class="form-control input-sm form-control-sm" (keypress)="numberOnly($event)" id="gvn"
                  name="gvn" formControlName="gvn" [readonly]="isViewData || eNatisResult" />
                <div class="form-control-feedback text-danger text-small">
                <p *ngIf="myForm.controls.gvn.required"> Gross Vehicle(GVM) is required</p>
              </div>
              </div> -->
            </div>
            <br />

            <!-- <div class="row"> -->
            <!-- <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Model Derivative
              </label>
              <input type="text" class="form-control input-sm form-control-sm" id="vehicle_model" name="vehicle_model"
                formControlName="vehicle_model" [attr.disabled]="eNatisResult!=null && eNatisResult.Vehicle_model!='' ? true : null" />
             <div class="form-control-feedback text-danger text-small">
              <p *ngIf="form.controls.registered_name.errors.required">Company registered name is required</p>
              <p *ngIf="form.controls.registered_name.errors.maxlength">No more than 100 characters allowed for Company Registered Name.</p>
            </div>
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Colour
              </label>
              <input type="text" maxlength="20" class="form-control input-sm form-control-sm" id="vehicle_colour"
                name="vehicle_colour" formControlName="vehicle_colour" [attr.disabled]="eNatisResult!=null && eNatisResult.Vehicle_colour!='' ? true : null" />
             <div class="form-control-feedback text-danger text-small">
              <p *ngIf="form.controls.registered_name.errors.required">Company registered name is required</p>
              <p *ngIf="form.controls.registered_name.errors.maxlength">No more than 100 characters allowed for Company Registered Name.</p>
            </div>
            </div> -->
            <!-- </div> -->

            <!-- 4th Row -->
            <div class="row">
              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  Seating Capacity<a class="red-asterik">*</a>
                </label>
                <input
                  type="text"
                  class="form-control input-sm form-control-sm"
                  (keypress)="numberOnly($event)"
                  id="seating_capacity"
                  name="seating_capacity"
                  formControlName="seating_capacity"
                  [readonly]="isViewData || eNatisResult"
                />
                <!-- <div class="form-control-feedback text-danger text-small">
            <p *ngIf="form.controls.registered_name.errors.required">Company registered name is required</p>
            <p *ngIf="form.controls.registered_name.errors.maxlength">No more than 100 characters allowed for Company Registered Name.</p>
            </div> -->
              </div>
              <div class="col-6 sp-fld">
                <label class="control-label hd-cat"></label>
                <label class="control-label hd-cat">
                  Registration Year<a class="red-asterik">*</a>
                </label>
                <input
                  type="text"
                  id="registration_year"
                  placeholder="yyyy"
                  name="registration_year"
                  formControlName="registration_year"
                  class="form-control input-sm form-control-sm"
                  [readonly]="isViewData || eNatisResult"
                />
                <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.is_leased.required">This field is required</p>
            </div> -->
              </div>
              <!-- <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                License Expiry Date<a class="red-asterik">*</a>
              </label>
              <input type="text" class="form-control input-sm form-control-sm" [readonly]="isViewData || eNatisResult" [minDate]="currentDate" ngbDatepicker
                #d5="ngbDatepicker" placeholder="dd/mm/yyyy" (click)="d5.toggle()" id="date_license_expiry"
                name="date_license_expiry" formControlName="date_license_expiry" />
              <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.date_license_expiry.required">License expiry date is required</p>
            </div>
            </div> -->
            </div>
            <br />

            <!-- 5th Row -->
            <div class="row">
              <div class="col-6 sp-fld">
                <div class="algn">
                  <label for="roadworthy_status"
                    >Roadworthy Status<a class="red-asterik">*</a></label
                  >
                  <input
                    type="text"
                    *ngIf="eNatisResult != null"
                    class="form-control input-sm form-control-sm"
                    id="roadworthy_status"
                    name="roadworthy_status"
                    formControlName="roadworthy_status"
                    [readonly]="eNatisResult"
                  />
                  <select
                    (change)="checkRoadworthy($event)"
                    type="text"
                    id="roadworthy_status"
                    *ngIf="eNatisResult == null"
                    name="roadworthy_status"
                    formControlName="roadworthy_status"
                    class="form-control-sm"
                    style="width: 100%; display: block"
                    [attr.disabled]="eNatisResult ? '' : null"
                  >
                    <option value="" selected disabled>Select status</option>
                    <option value="Roadworthy">Roadworthy</option>
                    <option value="Unroadworthy">Not roadworthy</option>
                  </select>
                </div>
              </div>

              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  Gross Vehicle (GVM)<a class="red-asterik">*</a>
                </label>
                <input
                  type="text"
                  class="form-control input-sm form-control-sm"
                  (keypress)="numberOnly($event)"
                  id="gvn"
                  name="gvn"
                  formControlName="gvn"
                  [readonly]="isViewData || eNatisResult"
                />
                <!-- <div class="form-control-feedback text-danger text-small">
                <p *ngIf="myForm.controls.gvn.required"> Gross Vehicle(GVM) is required</p>
              </div> -->
              </div>

              <!-- <div class="col-4 sp-fld" *ngIf="eNatisResult || eNatisResult!=null">
              <div class="algn">
                <label for='eNatis_num'>eNatis Number<a class="red-asterik">*</a></label>
                <input type="text" class="form-control input-sm form-control-sm" id="eNatis_num" name="eNatis_num"
                formControlName="eNatis_num" [readonly]="eNatisResult" />
              </div>
            </div> -->
            </div>
            <br />

            <!-- <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle State
              </label>
              <input type="text" class="form-control input-sm form-control-sm" id="vehicle_state" name="vehicle_state"
                formControlName="vehicle_state" />
              <div class="form-control-feedback text-danger text-small">
              <p *ngIf="form.controls.registered_name.errors.required">Company registered name is required</p>
              <p *ngIf="form.controls.registered_name.errors.maxlength">No more than 100 characters allowed for Company Registered Name.</p>
            </div>
            </div> -->
            <!-- <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Start Date<a class="red-asterik">*</a>
              </label>
              <input type="text" class="form-control input-sm form-control-sm" ngbDatepicker #d9="ngbDatepicker"
                placeholder="dd/mm/yyyy" (focus)="d9.toggle()" id="start_date" name="start_date"
                formControlName="start_date" />
            </div> -->

            <!-- 6th Row -->
            <div class="row">
              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  Vehicle Type<a class="red-asterik">*</a>
                </label>
                <select
                  class="form-control form-control-sm"
                  id="vehicle_type_id"
                  name="vehicle_type_id"
                  formControlName="vehicle_type_id"
                >
                  <option value="" disabled selected>
                    Select vehicle type
                  </option>
                  <option *ngFor="let type of vehicletypes" [ngValue]="type.id">
                    {{ type.description }}
                  </option>
                </select>
                <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.vehicle_make_id.required">Vehicle make is required</p>
            </div> -->
              </div>
              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  License Expiry Date<a class="red-asterik">*</a>
                </label>
                <input
                  type="text"
                  class="form-control input-sm form-control-sm"
                  [readonly]="isViewData || eNatisResult"
                  [minDate]="currentDate"
                  ngbDatepicker
                  #d5="ngbDatepicker"
                  placeholder="dd/mm/yyyy"
                  (click)="d5.toggle()"
                  id="date_license_expiry"
                  name="date_license_expiry"
                  formControlName="date_license_expiry"
                />
                <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.date_license_expiry.required">License expiry date is required</p>
            </div> -->
              </div>

              <div class="col-4 sp-fld">
                <label class="control-label hd-cat"></label>
                <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.vin.required">VIN or Chassis number is required</p>
            </div> -->
              </div>
            </div>

            <!--Row -->
            <div class="row">
              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  Belonging Depot
                </label>
                <select
                        class="form-control form-control-sm"
                        #depot_id
                        name="depot_id"
                        formControlName="depot_id"
                        [attr.disabled]="disallowEdit ? '' : null"
                >
                  <option
                          *ngFor="let depot of ddlDepots"
                          [value]="depot.id"
                          [selected]="depot.name == selectedDepot"
                  >
                    {{ depot.name }}
                  </option>
                </select>
              </div>
              <div class="col-4 sp-fld">
                <div class="algn">
                  <label for="is_leased"
                    >Is the vehicle leased?<a class="red-asterik">*</a></label
                  >
                  <select
                    type="text"
                    id="is_leased"
                    name="is_leased"
                    formControlName="is_leased"
                    class="form-control-sm"
                    (change)="LeaseChange($event)"
                  >
                    <option value="" disabled selected>Select</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
                <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.is_leased.required">This field is required</p>
            </div> -->
              </div>


              <!-- <div class="col-4 sp-fld">
                  <div class="send-confirmation-link-via opensans-normal-white-16px">
                      <label for='is_leased'>Is the vehicle leased?<a class="red-asterik">*</a></label>
      
                  <input type="radio" style="height:20px;width:20px" name="corspd-type" value="1" (click)="LeaseChange()" /> EMAIL
                  <input type="radio" style="height:20px;width:20px" name="corspd-type" value="2" (click)="LeaseChange()" /> SMS
                </div>
            </div> -->
            </div>

            <br />

            <!-- <div class="row">
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Owner Name<a class="red-asterik">*</a>
              </label>
              <input type="text" id='vehicle_owner' name="vehicle_owner" formControlName="vehicle_owner"
                class="form-control input-sm form-control-sm" [attr.disabled]="eNatisResult!=null && eNatisResult.Ownership!='' ? true : null" />
             <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.vehicle_owner.required">Vehicle owner name is required</p>
            </div>
            </div>
          </div> -->

            <!-- 7th Row -->
            <div class="row">
              <ng-container *ngIf="leased == 'true' || leased == true">
                <div class="col-4 sp-fld">
                  <label class="control-label hd-cat">
                    Lessor Name<a class="red-asterik">*</a>
                  </label>
                  <input
                    type="text"
                    class="form-control input-sm form-control-sm"
                    id="vehicle_lessor"
                    name="vehicle_lessor"
                    formControlName="vehicle_lessor"
                    [readonly]="isViewData"
                  />
                  <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.vehicle_lessor.required">Lessor name is required</p>
            </div> -->
                </div>
                <div class="col-4 sp-fld">
                  <label class="control-label hd-cat">
                    Lessee Name<a class="red-asterik">*</a>
                  </label>
                  <!-- <input type="text"  class="form-control input-sm form-control-sm" id='vehicle_lessee' name="vehicle_lessee" formControlName="vehicle_lessee"/> -->
                  <input
                    type="text"
                    class="form-control input-sm form-control-sm"
                    id="vehicle_lessee"
                    name="vehicle_lessee"
                    formControlName="vehicle_lessee"
                    [readonly]="isViewData"
                  />
                  <div class="form-control-feedback text-danger text-small">
                    <!-- <p *ngIf="myForm.ontrols.vehicle_lessee.required">Lessee name is required</p> -->
                  </div>
                </div>
                <div class="col-4 sp-fld">
                  <label class="control-label hd-cat">
                    Expiry Date Of Lease<a class="red-asterik">*</a>
                  </label>
                  <input
                    type="text"
                    class="form-control input-sm form-control-sm"
                    id="date_lease_expiry"
                    placeholder="dd/mm/yyyy"
                    [placement]="'top'"
                    [minDate]="currentDate"
                    ngbDatepicker
                    #d5="ngbDatepicker"
                    (click)="d5.toggle()"
                    name="date_lease_expiry"
                    formControlName="date_lease_expiry"
                  />
                  <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.date_lease_expiry.required">Expiry date of lease is required</p>
            </div> -->
                </div>
              </ng-container>
            </div>

            <!-- Documents -->
            <div *ngIf="isViewData != true">
              <div
                class="col-md-12"
                *ngIf="isDocumentLoading"
                style="
                  position: fixed;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  z-index: 99;
                "
              >
                <app-busy [message]="message"></app-busy>
              </div>
              <div
                class="card border-light shadow-sm"
                style="background-color: #f5f8ff !important"
              >
                <div class="contact-details opensans-semi-bold-sapphire-30px">
                  <span class="opensans-semi-bold-sapphire-30px"
                    >Vehicle Details</span
                  >
                </div>
                <div class="rectangle-34"></div>
                <span class="opensans-semi-bold-black-16px-2"
                  >Please ensure documents being submitted are clear and
                  visible, any document that is not clear and visible will be
                  rejected.</span
                >
                <span class="opensans-semi-bold-black-16px-2"
                  >All foreign documents must be translated by a certified
                  translator into English.</span
                >

                <div class="row m-0">
                  <table style="width: 100%">
                    <ng-container
                      *ngFor="let UserDocument of uploadedDocs; let i = index"
                    >
                      <tr>
                        <td>
                          <div
                            class="contact-details opensans-bold-sapphire-20px"
                          >
                            <span class="opensans-bold-sapphire-20px">{{
                              UserDocument.description
                            }}</span>
                          </div>
                          <div class="rectangle-34"></div>
                          <br />
                          <div>
                            <!-- {{filename}} -->
                          </div>
                          <div
                            class="dropzone"
                            fileDragDrop
                            (filesChangeEmiter)="
                              onFileChange($event, UserDocument.id)
                            "
                          >
                            <div class="text-wrapper">
                              <div class="centered">
                                <img
                                  src="/assets/upload_icon.png"
                                  style="width: 21.33px"
                                />
                                <input
                                  id="fileuploads{{ UserDocument.id }}"
                                  #fileuploads{{UserDocument.id}}
                                  type="file"
                                  style="width: 100px"
                                  (change)="
                                    handleTempFileInput($event, UserDocument.id)
                                  "
                                />
                                <br />
                                <label for="fileuploads{{ UserDocument.id }}"
                                  ><span class="textLink"
                                    >Drag and drop files here or click to search
                                    on your computer</span
                                  >
                                  <br /><br />
                                  <span
                                    style="
                                      text-decoration: underline;
                                      color: #274c9c;
                                    "
                                    >Upload file</span
                                  ></label
                                >
                              </div>
                            </div>
                          </div>
                        </td>
                        <td></td>
                        <td style="padding-right: 20px"></td>

                        <td></td>
                      </tr>
                      <label
                        ><span class="txt-max">
                          Max file size {{ maxMB }} PDF format.</span
                        ></label
                      >
                      <tr *ngFor="let Document of viewDocuments">
                        <td
                          *ngIf="UserDocument.id == Document.document_type_id"
                        >
                          <div class="card">
                            <h5 class="card-title">Files Uploaded</h5>

                            <div class="card-body">
                              <!-- <h2>Files Uploaded(0)</h2> -->

                              <div class="row">
                                <div class="col-sm bg-light">
                                  {{ Document.file_name }}
                                </div>
                                <div class="col-sm bg-light">PDF</div>
                                <div class="col-sm bg-light">
                                  <span style="float: right !important">
                                    <div class="file-upload-icons-group">
                                      <a
                                        ><img
                                          title="View Document"
                                          class="file-upload-icon"
                                          src="/assets/visibility.png"
                                          alt="visibility"
                                          data-toggle="modal"
                                          data-target="#exampleModalLong"
                                          (click)="
                                            viewTempDoc(
                                              Document.document_link,
                                              Document.file_name
                                            )
                                          "
                                      /></a>
                                      <img
                                        title="Delete Document"
                                        class="file-upload-icon"
                                        (click)="deleteTempDoc(Document)"
                                        src="/assets/delete.png"
                                        alt="delete"
                                      />
                                    </div>
                                    <!-- <span title="Upload another of the same type" *ngIf="UserDocument.multiple_allowed == true" class="btn btn-primary btn-sm"><i
                              class="fa fa-plus" aria-hidden="true" (click)="extraDoc(UserDocument)"></i></span> -->
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>

                        <td></td>
                      </tr>
                    </ng-container>

                    <tr *ngIf="uploadedDocs?.length == 0">
                      <td>No Documents found</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <br />
          </form>
        </div>
        <div class="modal-footer">
          <!-- <button type="button"  class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="SaveModal()" *ngIf="isEditData==false">Add Vehicle</button>
        <button type="button"  class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="SaveModal()" *ngIf="isEditData==true">Save Vehicle</button> -->
          <button
            type="button"
            class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2 myButton"
            (click)="SaveModal()"
            *ngIf="isEditData == false && isViewData == false"
          >
            Save Vehicle
          </button>
          <button
            type="button"
            class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"
            (click)="SaveModal()"
            *ngIf="isEditData == true && isViewData == false"
          >
            Save Vehicle
          </button>
          <button
            type="button"
            class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"
            (click)="CloseModal()"
            *ngIf="isViewData == true"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <button
    id="btnShowUploadDocument"
    data-dismiss="modal"
    title="Add a vehicle"
    style="visibility: hidden"
    data-toggle="modal"
    data-target="#uploadDocuments"
  ></button>

  <div style="visibility: hidden; height: 2px; width: 2px">
    <pdf-viewer
      *ngIf="pdfSrc"
      [style.background-image]="pdfSrc"
      [src]="pdfSrc"
      [render-text]="true"
      style="height: 2px; width: 2px"
      [original-size]="false"
      [autoresize]="true"
    ></pdf-viewer>
  </div>

  <!--Upload Documents-->
  <div
    class="modal fade"
    id="uploadDocuments"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLongTitle"
    data-backdrop="false"
    style="background-color: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            Upload Documents
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            #closebutton
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-xl">
          <div
            class="col-md-12"
            *ngIf="isDocumentLoading"
            style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 99;
            "
          >
            <app-busy [message]="message"></app-busy>
          </div>
          <div class="card border-light shadow-sm">
            <label
              ><strong>Document Uploads</strong
              ><span class="txt-max">
                Max file size {{ maxMB }}MB {{ dtype }}</span
              ></label
            >
            <div class="row m-0">
              <table style="width: 100%">
                <tr *ngFor="let UserDocument of viewDocuments">
                  <td>
                    <div class="contact-details opensans-bold-sapphire-20px">
                      <span class="opensans-bold-sapphire-20px">{{
                        UserDocument.description
                      }}</span>
                    </div>
                    <div class="rectangle-34"></div>
                    <br />
                    <div class="overlap-group13">
                      <div class="rectangle-125"></div>
                      <div
                        class="files-uploaded-1 opensans-semi-bold-black-20px"
                      >
                        <span class="opensans-semi-bold-black-20px"
                          >Files Uploaded</span
                        >
                      </div>
                      <div class="overlap-group2 opensans-normal-black-20px-2">
                        <div class="x-certificate">
                          <span class="opensans-normal-black-20px-2">{{
                            UserDocument.file_name
                          }}</span>
                        </div>
                        <div class="file-upload-icons-group">
                          <img
                            title="View Document"
                            class="file-upload-icon"
                            src="/assets/visibility.png"
                            alt="visibility"
                            aria-hidden="true"
                            data-toggle="modal"
                            data-target="#exampleModalLong"
                            (click)="
                              viewDoc(
                                UserDocument.shareId,
                                UserDocument.document_link
                              )
                            "
                          />
                          <img
                            title="Delete Document"
                            class="file-upload-icon"
                            (click)="deleteDoc(UserDocument)"
                            src="/assets/delete.png"
                            alt="delete"
                          />
                          <!-- <img *ngIf="UserDocument.multiple_allowed == true" title="Upload another of the same type" class="file-upload-icon" aria-hidden="true" (click)="extraDoc(UserDocument)" src="/assets/add.png" alt="delete" /> -->
                        </div>
                      </div>
                    </div>

                    <div></div>
                    <!-- <div> -->
                    <!-- <span title="Delete Document"  s class="btn btn-danger btn-sm" (click)="deleteDoc(UserDocument)"><i class="fa fa-trash-o fa-fw"></i></span>
                  &nbsp;  &nbsp; <span title="View Document"  class="btn btn-success btn-sm" ><i class="fa fa-eye" aria-hidden="true" data-toggle="modal" data-target="#exampleModalLong" (click)="viewDoc(UserDocument.shareId,UserDocument.document_link)"></i></span> -->
                    <!-- &nbsp;  &nbsp; <span title="Upload another of the same type" *ngIf="UserDocument.multiple_allowed == true" class="btn btn-primary btn-sm" ><i class="fa fa-plus" aria-hidden="true" (click)="extraDoc(UserDocument)"></i></span> -->
                    <!-- </div> -->
                  </td>

                  <td></td>
                </tr>
                <ng-container *ngFor="let UserDocument of uploadedDocs">
                  <tr *ngIf="UserDocument.document_link == null">
                    <td>
                      <div class="contact-details opensans-bold-sapphire-20px">
                        <span class="opensans-bold-sapphire-20px">{{
                          UserDocument.description
                        }}</span>
                      </div>
                      <div class="rectangle-34"></div>
                      <br />
                      <div>
                        {{ filename }}
                      </div>
                      <div
                        class="dropzone"
                        fileDragDrop
                        (filesChangeEmiter)="
                          onFileChange($event, UserDocument.id)
                        "
                      >
                        <div class="text-wrapper">
                          <div class="centered">
                            <img
                              src="/assets/upload_icon.png"
                              style="width: 21.33px"
                            />
                            <input
                              id="fileupload"
                              #fileupload
                              type="file"
                              style="width: 100px"
                              (change)="
                                handleFileInput($event, UserDocument.id)
                              "
                            />
                            <br />
                            <label for="fileupload"
                              ><span class="textLink"
                                >Drag and drop files here or search on your
                                computer</span
                              >
                              <br /><br />
                              <span></span>Upload</label
                            >
                          </div>
                        </div>
                      </div>
                    </td>
                    <td></td>
                    <td style="padding-right: 20px">
                      <!-- <input id="fileupload" #fileupload type="file" style="width:100px;" (change)="handleFileInput($event,UserDocument.id)" /> -->
                    </td>

                    <td></td>
                  </tr>
                </ng-container>

                <tr *ngIf="uploadedDocs?.length == 0">
                  <td>No Documents found</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            data-dismiss="modal"
            class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade"
    id="exampleModalLong"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLongTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            Document Uploaded
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-lg">
          <img *ngIf="img" [src]="img" width="780" />
          <pdf-viewer
            *ngIf="pdfSrc"
            [style.background-image]="pdfSrc"
            [src]="pdfSrc"
            [render-text]="true"
            style="display: block; min-height: 250px"
            [original-size]="false"
            [autoresize]="true"
          ></pdf-viewer>

          <!-- <ngx-loading [show]="isLoadingImg"></ngx-loading> -->
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"
            data-dismiss="modal"
          >
            Close
          </button>
          <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
        </div>
      </div>
    </div>
  </div>
</div>
